import React from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import config from "@/config";
import { privacyChangeDev } from "@/utils/privacydev";
import styles from "./privacy.module.scss";

const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});

const S = ({ children }) => <span className={styles.sensitive}>{children}</span>;

const sections = [
  {
    title: "我们收集哪些信息",
    items: [
      <>注册时需要您的<S>手机号码</S>和密码</>,
      <>驾驶员需提供<S>姓名、身份证、面部识别特征、驾驶证、行驶证、银行卡信息</S></>,
      <>服务过程中收集<S>位置信息、行踪轨迹、录音录像信息</S></>,
      <>支付时涉及<S>支付账户信息、银行卡号</S></>,
      <>设备信息：<S>设备型号、IMEI、MAC地址、操作系统版本</S>等</>,
    ],
  },
  {
    title: "我们为何收集",
    items: [
      "提供网约车服务（接单、导航、计费）",
      "验证身份，确保符合网约车驾驶员资质",
      "保障行程安全，处理司乘纠纷",
      "完成支付结算和提现功能",
      "改善服务质量和用户体验",
    ],
  },
  {
    title: "我们与谁共享",
    items: [
      <>第三方聚合平台：<S>手机号、身份证、驾驶证、位置信息</S>（用于资质核验和订单撮合）</>,
      <>关联公司：<S>账户信息</S>（用于统一账户体系）</>,
      "业务合作伙伴：实名验证、人脸识别、支付等服务提供商",
      "政府监管部门：依法律要求提供必要信息",
    ],
  },
  {
    title: "我们如何保护",
    items: [
      "所有个人信息加密存储在中国内地服务器",
      "数据传输过程中使用加密传输协议",
      "严格的数据访问权限控制和审计制度",
      "定期进行安全评估和信息安全培训",
      "建立安全事件应急响应机制",
    ],
  },
  {
    title: "您的权利",
    items: [
      "访问：查看您存储在平台的个人信息",
      "更正：修改错误的个人信息",
      "删除：申请删除个人信息",
      "撤回同意：关闭设备权限或退订信息",
      "注销账号：永久删除账号及相关数据",
    ],
  },
  {
    title: "第三方SDK",
    items: [
      "集成了腾讯地图/定位/导航SDK（地图及位置服务）",
      "集成了百度人脸识别SDK（身份验证）",
      "集成了极光推送SDK（消息推送）",
      "集成了微信OpenSDK（分享、登录、支付）",
      "集成了科大讯飞语音SDK（语音播报）",
    ],
  },
  {
    title: "未成年人保护",
    items: [
      "未满18周岁需监护人授权后使用",
      "未满14周岁需监护人同意并阅读本政策",
    ],
  },
  {
    title: "联系我们",
    items: [
      "客服功能：通过APP内在线客服联系",
      "邮箱：82269008@qq.com",
      "我们将在15个工作日内处理您的反馈",
    ],
  },
];

const SimplePrivacy = (props) => {
  const company = props.tenant;
  const history = useHistory();

  return (
    <div className={styles.privacyPage}>
      <h1 className={styles.docTitle}>隐私政策（简易版）</h1>
      <p className={styles.docMeta}>版本：2021年06月22日 &nbsp;|&nbsp; 生效：2021年06月22日</p>

      <nav className={styles.pageNav}>
        <span className={styles.pageNavLink} onClick={() => history.push("/privacytext")}>完整版</span>
        <span className={`${styles.pageNavLink} ${styles.active}`}>简易版</span>
        <span className={styles.pageNavLink} onClick={() => history.push("/privacytext/sdk")}>第三方SDK清单</span>
      </nav>

      <div className={styles.introBox}>
        以下是"{company}"隐私政策的核心要点摘要。涉及<S>个人敏感信息</S>的内容已显著标识，请重点关注。
        如需了解完整条款，请查阅<span className={styles.link} onClick={() => history.push("/privacytext")}>完整版隐私政策</span>。
      </div>

      {sections.map((section, i) => (
        <div key={i} className={styles.simpleSection}>
          <h3>{section.title}</h3>
          <ul>
            {section.items.map((item, j) => (
              <li key={j}>{item}</li>
            ))}
          </ul>
        </div>
      ))}

      <div className={styles.footer}>
        <div className={styles.footerLinks}>
          <a onClick={() => history.push("/privacytext")}>完整版隐私政策</a>
          <a onClick={() => history.push("/privacytext/sdk")}>第三方SDK清单</a>
          <a onClick={() => history.push("/service")}>服务协议</a>
        </div>
        <p>&copy; {new Date().getFullYear()} {company} &nbsp;开发者：{privacyChangeDev()}{config.isYW ? ` · 客服电话：${config.TEL}` : ""}</p>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(SimplePrivacy);
